<template>
	<div class="container scenicmianspots" v-if="scenicmianspots.length >0">
			<div class="panel panel-default">
				<div class="panel-heading">
					<div class="category">
						<a class="category-top">{{name}}</a>
						<a class="category-bottom">{{enname}}</a>
					</div>
				</div>
				<div class="panel-body" style="padding:0px 5px;padding-bottom:10px;max-height:500px;overflow-y: scroll;">
					<van-tree-select :items="scenicmianspots" :main-active-index.sync="scenicmianspotsActive">
					  <template #content>
					    <div v-for="(item,index) in scenicmianspots" :key="item.id">
							<p class="fsa" v-if="scenicmianspotsActive == index">{{item.SpotName}}</p>
					    	<div class="scenicmianspots-details" v-if="scenicmianspotsActive == index" v-html="item.Details">
					    	</div>
					    </div>
					  </template>
					</van-tree-select>
					
				</div>
			</div>
		</div>
</template>

<script>

export default {
  data(){
    return {
      show: false,
      scenicmianspotsActive: 0
    }
  },
  props: {
  	scenicmianspots: {
  		type: Array||Object,
  		require: true
  	},
  	name: {
  		type: String,
  		default: '乡村旅游'
  	},
  	enname: {
  		type: String,
  		default: 'Rural tourism'
  	}
  },
  components: {  },
  mounted: function () {
  },
  methods: {
  }
};

</script>
<style>
  .scenicmianspots .van-sidebar-item{background-color: rgb(226,226,226);font-size: 16px;}
  .scenicmianspots .van-tree-select__nav-item {
    padding: 8px 12px;
  }
  .van-tree-select__nav{
	  background-color: #fff;
  }
  .scenicmianspots-details{ padding-left: 5px; }
  .scenicmianspots-details p span{
	  font-size: 14px !important
  }
</style>
<style scope>
.container.scenicmianspots .van-sidebar-item.van-sidebar-item--select.van-tree-select__nav-item{
 background-color: rgba(234, 85, 23);
 border-radius: 8px;
 box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
 border: 0;
}
.scenicmianspots .van-sidebar-item{
	box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
	border-radius: 8px;
	margin-bottom: 10px;
	font-size: 12px;
	width: 84%;
	margin-left: auto;
	margin-right: auto;
	 display: flex;
 	align-items: center;
 	justify-content: center;
}
.scenicmianspots-details img{
	border-radius: 8px;
}
.container.scenicmianspots .van-tree-select__nav-item{
	margin-top: 2px;
	border: 0;
}
  .scenicmianspots .van-tree-select {
	  height: auto!important; font-size: 14px;
	}
	.van-sidebar-item__text{
	white-space: nowrap;     /*强制不换行*/
	overflow: hidden;        /*超出部分隐藏*/
	text-overflow: ellipsis; /*超出部分显示省略号*/
	}
	.fsa{
		text-align: center;
	}
</style>